import { Outlet, Navigate, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MaintenanceGate from "./MaintenanceGate";
import { useAuth } from "@/contexts/AuthContext";

// Routes a doctor with incomplete profile is allowed to visit
const PROFILE_EXEMPT_PATHS = new Set([
  "/complete-profile",
  "/auth/callback",
  "/login",
  "/logout",
]);

function isProfileIncomplete(user) {
  if (!user || user.role !== "doctor") return false;
  return !((user.specialty || "").trim() && (user.whatsapp || "").trim());
}

export default function PublicLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Block any navigation while the doctor hasn't finished onboarding,
  // except for the onboarding page itself or auth-related routes.
  if (
    !loading &&
    isProfileIncomplete(user) &&
    !PROFILE_EXEMPT_PATHS.has(location.pathname)
  ) {
    return <Navigate to="/complete-profile" replace />;
  }

  return (
    <MaintenanceGate>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </MaintenanceGate>
  );
}
